import styled, { css } from 'styled-components';
import {
  btnReset,
  getTextType,
  borderClipPath,
  getGridSpans,
  mq,
  getSpace,
  getTransition
} from '../../../stylesheets/tools';

const easing = 'cubic-bezier(.48,0,.5,1)';

const StyledSearchBar = styled.div`
  position: relative;
  width: 100%;
  color: #fff;
  transform: translateX(40px);
  opacity: 0;
  animation: searchSlideIn 0.33s ${easing} forwards;

  @keyframes searchSlideIn {
    from {
      transform: translateX(40px);
      opacity: 0;
    }

    to {
      transform: translateX(0);
      opacity: 1;
    }
  }

  [data-whatinput='mouse'] &,
  [data-whatinput='touch'] & {
    outline: 0;
  }

  .searchBar__input-wrapper {
    position: relative;
    height: calc(100vh - 90px);
    display: flex;
    align-items: flex-end;
    flex-wrap: wrap;
    ${getTransition()}
    ${getGridSpans('width', { m: 12, l: 10 })}
    ${getGridSpans('margin-left', { m: 0, l: [1, 'spread'] })}

    height: 130px;

    ${mq('m')} {
      height: 300px;
    }
  }

  .searchBar__error {
    position: relative;
    text-align: center;
    padding-top: 5px;
  }

  .searchBar__input {
    width: 100%;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: stretch;
    ${borderClipPath('#000', '#262626')}

    input {
      ${getTextType('subline')}
      width: calc(100% - 60px);
      background: none;
      border: none;
      color: rgba(255, 255, 255, 0.3);
      text-transform: uppercase;
      padding: ${getSpace('xxs')} 0px ${getSpace('xxs')} ${getSpace('xxs')};
      margin: 0;
      z-index: 1;
      flex-grow: 2;
      ${getTransition()}
      ${mq('m')} {
        ${getTextType('primary')}
      }

      &:focus {
        color: #fff;
      }
      &[type='search']::-ms-clear {
        display: none;
        width: 0;
        height: 0;
      }
      &[type='search']::-ms-reveal {
        display: none;
        width: 0;
        height: 0;
      }
      &[type='search']::-webkit-search-decoration,
      &[type='search']::-webkit-search-cancel-button,
      &[type='search']::-webkit-search-results-button,
      &[type='search']::-webkit-search-results-decoration {
        display: none;
      }

      [data-whatinput='mouse'] &,
      [data-whatinput='touch'] & {
        outline: none;
      }

      [data-whatintent='mouse'] &:focus {
        outline: none;
      }

      ${mq('m')} {
        padding: 20px 0px 20px 20px;
        ${getTransition()}
      }

      &::placeholder {
        color: rgba(255, 255, 255, 0.3);
        ${getTransition()}
      }
    }

    button {
      appearance: none;
      border: 0;
      margin: 0;
      background: transparent;
      cursor: pointer;
      padding: ${getSpace('xxs')} ${getSpace('xxs')} ${getSpace('xxs')} 0px;
      z-index: 1;
      opacity: 0.3;

      [data-whatinput='mouse'] &,
      [data-whatinput='touch'] & {
        outline: 0;
      }

      ${mq('m')} {
        padding: 20px 20px 20px 0px;
        ${getTransition()}
      }

      svg {
        width: 45px;
        color: white;
        height: ${getSpace('xxs')};

        ${mq('m')} {
          width: 80px;
          height: 26px;
        }
      }
    }

    &:focus-within {
      input,
      input::placeholder {
        color: #fff;
      }

      button {
        opacity: 1;
      }
    }
  }

  .searchBar__results {
    ul {
      list-style: none;
      padding: 0;
      margin: 0;

      .ais-Hits-item:first-of-type {
        .searchTeaser__link:before {
          height: 0;
        }
      }
    }
  }

  .searchBar__no-results {
    margin: ${getSpace('l')} 0;
    text-align: center;
  }

  .searchBar__teaser {
    animation: fade 1s;
  }

  @keyframes fade {
    0% {
      opacity: 0;
    }

    100% {
      opacity: 1;
    }
  }

  .ais-Hits-item:first-child {
    .searchTeaser__link::before {
      display: none;
    }
  }
`;

const StyledSearchButton = styled.button`
  ${btnReset}

  [data-whatinput='mouse'] &,
  [data-whatinput='touch'] & {
    outline: 0;
  }

  svg {
    fill: #000;
  }

  ${props =>
    props.inverted &&
    css`
      svg {
        fill: ${props.close ? props.theme.globalTheme.primary : '#fff'};
      }
    `}
`;

export { StyledSearchBar, StyledSearchButton };
